import { Projectile } from '../../../domain/projectile.js';
import { processDeadMinionNearbyExp } from '../minionNearbyExpSystem.js';

function fireMinionProjectile(minion, target, activeProjectiles, createFrostArrowMeshCallback, scene) {
  const pDomain = new Projectile({
    id: `minion-proj-${Date.now()}`,
    sourceEntity: minion,
    targetEntity: target,
    speed: 1200,
    damage: minion.ad
  });
  const pMesh = createFrostArrowMeshCallback ? createFrostArrowMeshCallback(false) : null;
  if (pMesh && scene) scene.add(pMesh);
  activeProjectiles.push({ domain: pDomain, mesh: pMesh });
}

function resolveMinionAttack(domain, dt, activeProjectiles, createFrostArrowMeshCallback, scene) {
  domain.isAttacking = true;
  domain.targetX = domain.x;
  domain.targetZ = domain.z;
  const event = domain.updateAttackCycle(dt);
  if (!event.fired || !event.target) return;
  if (domain.minionType === 'ranged' || domain.minionType === 'cannon') {
    fireMinionProjectile(domain, event.target, activeProjectiles, createFrostArrowMeshCallback, scene);
  } else {
    event.target.takeDamage(domain.ad, domain);
  }
}

function tickLivingMinion(m, allDamageableTargets, dt, mapBounds, wallBoxes, bushZones, impassableZones, activeProjectiles, createFrostArrowMeshCallback, scene) {
  const domain = m.domain;
  domain.updateAggro(allDamageableTargets);
  const enemyObstacles = allDamageableTargets.filter((t) => t && !t.isDead && t.team !== domain.team);
  if (domain.attackTarget && !domain.attackTarget.isDead) {
    if (domain.isInAttackRange(domain.attackTarget)) {
      resolveMinionAttack(domain, dt, activeProjectiles, createFrostArrowMeshCallback, scene);
    } else {
      domain.isAttacking = false;
      domain.targetX = domain.attackTarget.x;
      domain.targetZ = domain.attackTarget.z;
      domain.updatePosition(dt, enemyObstacles, mapBounds, wallBoxes, bushZones, impassableZones);
    }
  } else {
    domain.isAttacking = false;
    domain.followWaypoints(dt, allDamageableTargets, mapBounds);
  }
  domain.updateAbilities(dt);
}

/**
 * Active minion AI (aggro/attack/move) plus nearby XP for dead minions.
 */
export function updateActiveMinions({
  activeMinions = [],
  allDamageableTargets = [],
  championEntity,
  secondaries = [],
  dt = 0,
  mapBounds,
  wallBoxes,
  bushZones,
  impassableZones,
  activeProjectiles = [],
  createFrostArrowMeshCallback = null,
  scene = null
} = {}) {
  for (const m of activeMinions) {
    if (m.domain.isDead) continue;
    tickLivingMinion(
      m,
      allDamageableTargets,
      dt,
      mapBounds,
      wallBoxes,
      bushZones,
      impassableZones,
      activeProjectiles,
      createFrostArrowMeshCallback,
      scene
    );
  }
  processDeadMinionNearbyExp({
    activeMinions,
    champions: [
      championEntity,
      ...secondaries.filter((e) => e && e.type === 'champion')
    ],
    radius: 8.0
  });
}
